import React from 'react';
import { useTranslation } from 'react-i18next';
import { AuthProvider } from '../types/common';
import ButtonAuth from './auth-button';
import OutsideButton from './button-outside';
import SamsungButton from './button-samsung';

type SupportedAuthProvider = 'google' | 'facebook' | 'outside' | 'samsung' | 'wallet-connect';

export type AuthButtonInput = {
  name: SupportedAuthProvider;
  className: string;
  localeKey: string;
};

interface Props {
  onClick: (provider: AuthProvider) => void;
  providers: AuthButtonInput[];
  disabled?: boolean;
}

export default function AuthButtonList({ disabled = false, ...props }: Props): JSX.Element {
  const { t } = useTranslation();

  const { providers, onClick } = props;

  return (
    <>
      {providers.map((provider) => {
        if (provider.name === 'outside') {
          return (
            <OutsideButton
              key={provider.name}
              className={provider.className}
              text={t(provider.localeKey)}
              disabled={disabled}
              onClick={(): void => onClick(provider.name)}
            />
          );
        }
        if (provider.name === 'samsung') {
          return (
            <SamsungButton
              key={provider.name}
              className={provider.className}
              text={t(provider.localeKey)}
              disabled={disabled}
              onClick={(): void => onClick(provider.name)}
            />
          );
        }
        return (
          <ButtonAuth
            key={provider.name}
            className={provider.className}
            provider={provider.name}
            disabled={disabled}
            onClick={(): void => onClick(provider.name)}
          >
            {t(provider.localeKey)}
          </ButtonAuth>
        );
      })}
    </>
  );
}
